import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, wrapper, title, image, rightMargin, listBox } from './LastPageStyle';
import imgIT from '../../assets/media/data1.png';
import IndustryArea from '../../components/IndustryArea';

const ITLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>Alles was wir tun, richten wir auf Ihren Erfolg aus</div>
                <h2>Nutzen Sie die Erfahrung eines unabhängigen Partners</h2>
                <p>
                    Unsere Kunden profitieren von unseren Erfahrungen als Unternehmer, Manager und Berater auf
                    internationaler Ebene. Mit unseren Erfahrungen und den ausgewiesenen Fähigkeiten in der IT-Beratung
                    navigieren wir Ihre Projekte sicher ans Ziel.
                </p>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} style={{ height: '65mm' }} src={imgIT} alt="IT" />
                    <div className={listBox}>
                        <ul>
                            <li>Sicherstellung einer professionellen, geschäftsorientierten und bedarfsgerechten IT</li>
                            <li>Neutrale, anbieterunabhängige sowie kundenorientierte Unterstützung</li>
                            <li>Begleitung in der Umsetzung inklusive des Umsetzungs-Controllings</li>
                            <li>
                                Einsatz leistungsfähiger Werkzeuge für IT-Assessments, Benchmarking und
                                Umsetzungs-Controlling
                            </li>
                            <li>
                                Einbringen unserer internationalen IT-Erfahrungen aus der umsetzungsorientierten
                                Unternehmensberatung in Europa, Asien sowie Nordamerika
                            </li>
                            <li>
                                Nutzen des Know-hows aus weiteren Kernbereichen Strategie- und
                                Geschäftsmodellentwicklung, Ertrags- und Effizienzsteigerung, Prozessoptimierung,
                                Organisationsentwicklung, Restrukturierung, Supply Chain Management, Produktion sowie
                                Logistik
                            </li>
                        </ul>
                    </div>
                </div>
                <h2>Namhafte Kunden vertrauen uns</h2>
                <p>
                    Internationale Unternehmen vertrauen uns als Partner, um zielgerichtet «Business Excellence» zu
                    erreichen und profitabel zu wachsen.
                </p>

                <IndustryArea />
                <h2>Nachhaltige Resultate und ein attraktiver Payback</h2>
                <p>
                    Sie setzen auf ein erfahrenes Team. Unser Fokus auf «Business Excellence» und unsere ausgewiesene
                    Umsetzungsstärke garantieren Ihnen nachhaltige Resultate und eine rasche Amortisation der
                    Projektkosten.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default ITLastPage;
